<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('settings')">Settings</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> Custom Reports
    </h1>

    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
      </search-filter>
      <inertia-link v-if="this.can.create" class="btn-indigo" :href="route('custom-reports.create')">
        <span>Create</span>
        <span class="hidden md:inline">Custom Report</span>
      </inertia-link>
    </div>

    <table-wrapper :headers="['Name', 'Description']" :text-wrap="false" class="mb-4">
      <table-row v-for="customReport in customReports" :key="customReport.id">
        <table-cell :href="route('custom-reports.edit', [customReport.id])">{{ customReport.name }}</table-cell>
        <table-cell :href="route('custom-reports.edit', [customReport.id])">{{ customReport.description }}</table-cell>
        <table-cell-end :href="route('custom-reports.edit', [customReport.id])"></table-cell-end>
      </table-row>
      <table-row v-if="customReports.length === 0">
        <table-cell colspan="3">No custom reports found.</table-cell>
      </table-row>
    </table-wrapper>

  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import TableWrapper from "@/Shared/Table/TableWrapper"
import TableRow from "@/Shared/Table/TableRow"
import TableCell from "@/Shared/Table/TableCell"
import TableCellEnd from "@/Shared/Table/TableCellEnd"

export default {
  metaInfo: { title: 'Custom Reports' },
  components: {
    Icon,
    SearchFilter,
    TableWrapper,
    TableRow,
    TableCell,
    TableCellEnd,
  },
  layout: Layout,
  props: {
    filters: Object,
    customReports: Array,
    can: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
      },
    }
  },
  watch: {
    form: {
      handler: throttle(function() {
        let query = pickBy(this.form)
        this.$inertia.get(this.route('custom-reports.index'), query, { replace: true, preserveState: true })
      }, 150),
      deep: true,
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
